import { combineReducers } from 'redux';
import { Api } from '../services/base.api';
import { deploymentApi } from '../services/deployment.api';
import { envApi } from '../services/env.api';
import { ocmApi } from '../services/ocm.api';
import { timeZoneApi } from '../services/timezone.api';

const rootReducer = combineReducers({
  [Api.reducerPath]: Api.reducer,
  [envApi.reducerPath]: envApi.reducer,
  [deploymentApi.reducerPath]: deploymentApi.reducer,
  [timeZoneApi.reducerPath]: timeZoneApi.reducer,
  [ocmApi.reducerPath]: ocmApi.reducer,
});
export default rootReducer;
